<div edsSpacing="md">
  <table edsCol class="table table--secondary" style="width: 100%">
    <tbody class="table__body">
      <tr class="table__tr" *ngFor="let summary of summaryData">
        <ng-container *ngIf="summary?.valueType === 'PERIOD'">
          <td class="table__td text-align-left">
            {{ summary?.label }}
          </td>
          <td class="table__td text-align-right">
            {{ summary?.value }}
          </td>
        </ng-container>

        <ng-container *ngIf="summary?.valueType === 'RATE'">
          <td class="table__td text-align-left">
            {{ summary?.label }}
          </td>
          <td class="table__td text-align-right">
            {{ summary?.value | number: "1.2-2":"de-DE" }}%
          </td>
        </ng-container>

        <ng-container
          *ngIf="summary?.valueType === 'AMOUNT' && !summary?.showLegend"
        >
          <td class="table__td text-align-left">
            {{ summary?.label }}
          </td>
          <td class="table__td text-align-right">
            {{ summary?.currencySymbol }}
            {{ summary?.value | number: "1.2-2":"de-DE" }}
          </td>
        </ng-container>

        <ng-container
          *ngIf="summary?.valueType === 'AMOUNT' && summary?.showLegend"
        >
          <td class="table__td text-align-left">
            <span class="table__legend">
              <span
                class="table__legend-box"
                [style.background]="summary?.legendColor"
                edsPaddingRight="xs"
              >
              </span>
              <span edsPadding edsPaddingLeft="xs">{{ summary?.label }}</span>
            </span>
          </td>
          <td class="table__td text-align-right">
            {{ summary?.currencySymbol }}
            {{ summary?.value | number: "1.2-2":"de-DE" }}
          </td>
        </ng-container>
      </tr>
    </tbody>
  </table>
</div>
